<template>
    <div class="position-box security" :class="{theme:theme}">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
            <div class="title">{{$t('xgdlmm.title')}}</div>
        </div>
        <div class="cotainer">
           <div class="select-box mt15" @click.stop="down">
            <input class="section1-right section-type" type="text" disabled v-model="curWt">
            <img class="arrow" src="@/assets/down.png" alt="">
            </div>
            <div class="mt20"><input class="section1-right" v-model="answer" :placeholder="$t('mbwt.qtxda')"/></div>
            <div class="mt20 select-box">
              <input class="section1-right" type="password" v-model="pwd" ref="input1" :placeholder="$t('mbwt.qsrxmm')"/>
              <template v-if="isPwd1">
                <img v-if="!theme" v-show="pwd" src="@/assets/Log-In_close-eyes.png" style="width: .6rem" @click="shpass1" />
                <img v-else v-show="pwd" src="@/assets/theme/eyes.png" style="width: .6rem" @click="shpass1" />
             </template>
             <template v-else>
                <img v-if="!theme" v-show="pwd" src="@/assets/Log-In_eyes.png" style="width: .6rem" @click="shpass1" />
                <img v-else v-show="pwd" src="@/assets/theme/eyes2.png" style="width: .6rem" @click="shpass1" />
             </template>
            </div>
            <div class="mt20 select-box">
              <input class="section1-right" type="password" v-model="qrpwd" ref="input2" :placeholder="$t('lg.ppwd2')"/>
              <template v-if="isPwd2">
                <img v-if="!theme" v-show="qrpwd" src="@/assets/Log-In_close-eyes.png" style="width: .6rem" @click="shpass2" />
                <img v-else v-show="qrpwd" src="@/assets/theme/eyes.png" style="width: .6rem" @click="shpass2" />
              </template>
              <template v-else>
                <img v-if="!theme" v-show="qrpwd" src="@/assets/Log-In_eyes.png" style="width: .6rem" @click="shpass2" />
                <img v-else v-show="qrpwd" src="@/assets/theme/eyes2.png" style="width: .6rem" @click="shpass2" />
              </template>
            </div>
            <div class="link-tips" @click="link">{{$t('mbwt.sydqmmcz')}}</div>
            <button class="btn-submit btn-bg" @click="sure">{{$t('mbwt.tj')}}</button>
        </div>
        <div class="mask" v-show="isDown" @click="down"></div>
        <ul class="ul-box" v-show="isDown">
          <li class="list" v-for="(item,index) in wtArr" :key="index" @click.stop="select(item.id,item[lang])">{{item[lang]}}</li>
        </ul>
    </div>
</template>

<script>
import {newLang} from '../utils/problem.js'
export default {
    name: 'securityModPwd',
    data () {
        return {
          theme: false,
          lang: '',
          account: '',
          wtId: 1,
          curWt: '',
          wtArr: [],
          answer: '',
          pwd: '',
          qrpwd: '',
          isDown: false,
          isPwd1: true,
          isPwd2: true,
        }
    },
    created(){
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.lang = localStorage.getItem('language') || 'en';
      this.wtArr = newLang.problem;
      this.curWt = this.wtArr[0][this.lang];
      this.account = localStorage.getItem('username');
    },
    mounted() {
      $("input").keyup(function(){	//去掉空格
        $(this).val($(this).val().replace(/[, ]/g,''));
      });
    },
    methods: {
      shpass1() {
        if(this.isPwd1){
          this.isPwd1 = false;
          this.$refs.input1.type = "text";
        }else{
          this.isPwd1 = true;
          this.$refs.input1.type = "password";
        }
      },
      shpass2() {
        if(this.isPwd2){
          this.isPwd2 = false;
          this.$refs.input2.type = "text";
        }else{
          this.isPwd2 = true;
          this.$refs.input2.type = "password";
        }
      },
        goBack(){
            this.$router.push('/securityCenter')
        },
        link(){
            this.$router.push('/modifyPwd')
        },
        down(){
            this.isDown = !this.isDown;
        },
        select(id,title){
            this.wtId = id;
            this.curWt = title;
            this.isDown = false;
        },
        sure(){
          var reg = /^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+){6,12}$/;
          var params = {
              account : this.account,
              password : this.pwd,
              password_again : this.qrpwd,
              token: 1,
              sec_question: this.curWt,
              sec_answer: this.answer
          }
          if(!this.answer || this.answer == null){
            this.$toast.center(this.$t('mbwt.qtxda'));
            return false;
          }
          if(!this.pwd || this.pwd == null){
            this.$toast.center(this.$t('mbwt.qsrxmm'));
            return false;
          }else if(!reg.test(this.pwd)){
            this.$toast.center(this.$t('lg.ppwd2'));
            return false;
          }
          if(this.pwd != this.qrpwd){
            this.$toast.center(this.$t('lg.ppwd2'));
            return false;
          }
          this.$ajax.post('/web/updatePassword',params).then((res) => {
            let resData = res.data;
            if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                setTimeout(() => {
                    this.$router.push('/securityCenter')
                }, 1000)
            }else{
                this.$toast.center(resData.message);
                return;
            }
          }).catch(function(err){
              console.log(err)
          })
        }
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        font-size: .56rem;
        line-height: 1.6rem;
        background: #fff;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .45rem;
        right: .45rem;
        top: 2.4rem;
        bottom: 0;
        background: #fff;
        overflow-y: scroll;
    }
    .security input::-webkit-input-placeholder {
        color: #666;
        font-size: .36rem;
    }
    .security-tips {
        display: flex;
        align-items: center;
        margin: .45rem 0 .9rem;
        color: #666;
        font-size: .54rem;
        font-weight: bold;
        line-height: .6rem;
    }
    .select-box{
        position: relative;
        flex: 1;
    }
    .ul-box{
      position: absolute;
      bottom: 0;
      left: -1px;
      right: 0;
      z-index: 1000;
      /* border: 1px solid #b3b3b3; */
      /* border-radius: .18rem; */
      background: #fff;
      box-sizing: border-box;
    }
    .ul-box .list{
      height: 1.2rem;
      font-size: .42rem;
      line-height: 1.2rem;
      border-bottom: 1px solid #b3b3b3;
      text-align: center;
    }
    .ul-box .list:last-child{
        border-bottom: none;
    }
    .select-box .arrow{
        position: absolute;
        top: 50%;
        right: .3rem;
        width: .54rem;
        margin-top: -.18rem;
    }
    .section1-right {
        width: 100%;
        height: 1.26rem;
        font-size: .4rem;
        line-height: 1.26rem;
        color: #000;
        border-radius: .18rem;
        background: #f8f8f8;
        box-sizing: border-box;
        text-indent: .18rem;
    }
    .section1-right.section-type{
        padding-right: 1.2rem;
        border-radius: .18rem;
    }
    .btn-submit {
        display: block;
        width: 100%;
        margin-top: 1.2rem;
    }
    .link-tips{
        margin-top: .45rem;
        color: #588bf8;
        font-size: .42rem;
        text-align: right;
    }
    .mt20.select-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-radius: 0.18rem;
      background: #f8f8f8;
    }
    .mt20.select-box .section1-right{
      border-radius: 0;
    }
    .mt20.select-box img{
      margin-right: .3rem;
    }
    .theme .mt20.select-box{
      background: #131e30;
    }
</style>



// WEBPACK FOOTER //
// src/pages/securityModPwd.vue